(function () {
  var namespace = window.EvvoProductCoupons || {};

  function copyCoupon(button) {
    var code = button.getAttribute('data-evvo-copy-code');
    var label = button.querySelector('.evvo-coupon-card__copy-label');
    var originalLabel = label ? label.textContent : '';

    function showCopied() {
      if (!label) return;
      label.textContent = 'Copied';
      window.setTimeout(function () {
        label.textContent = originalLabel;
      }, 1600);
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(showCopied);
      return;
    }

    var input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
    showCopied();
  }

  function setActive(root, index) {
    var dots = root.querySelectorAll('[data-evvo-coupons-dot]');
    dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function goToCard(root, index) {
    var track = root.querySelector('[data-evvo-coupons-track]');
    var cards = root.querySelectorAll('[data-evvo-coupon-card]');
    var target = cards[index];
    if (!track || !target) return;

    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function getActiveIndex(track, cards) {
    var closestIndex = 0;
    var closestDistance = Infinity;

    cards.forEach(function (card, index) {
      var distance = Math.abs(card.offsetLeft - track.offsetLeft - track.scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function init(root) {
    if (root.getAttribute('data-evvo-coupons-ready') === 'true') return;

    var track = root.querySelector('[data-evvo-coupons-track]');
    var cards = root.querySelectorAll('[data-evvo-coupon-card]');
    var ticking = false;

    if (!track || !cards.length) return;
    root.setAttribute('data-evvo-coupons-ready', 'true');

    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive(root, getActiveIndex(track, cards));
        ticking = false;
      });
    }, { passive: true });

    root.querySelectorAll('[data-evvo-coupons-dot]').forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        goToCard(root, index);
      });
    });
  }

  namespace.initAll = function (scope) {
    (scope || document).querySelectorAll('[data-evvo-coupons]').forEach(init);
  };

  if (!namespace.eventsBound) {
    document.addEventListener('click', function (event) {
      var copyButton = event.target.closest('[data-evvo-copy-code]');
      if (copyButton) copyCoupon(copyButton);
    });

    document.addEventListener('shopify:section:load', function (event) {
      namespace.initAll(event.target);
    });

    namespace.eventsBound = true;
  }

  window.EvvoProductCoupons = namespace;
  namespace.initAll(document);
})();
